define('vspot-angular/services/assigners-service',[], function () {
    'use strict';

    return ['resources.Assigners', function (Assigners) {
        return {
            /**
             * Move spots from an assigner to an assignee.
             * @param  {int}    activityId      Id of the activity
             * @param  {str}    accessKey       Access key to authenticate the user with
             * @param  {int}    fromVolId       The id of the volunteer (assigner) we are moving the job assignment from
             * @param  {int}    toVolId         The id of the volunteer (assignee) we are moving the job assignment to
             * @param  {int}    jobId           The id of the job this assignment is for
             * @param  {int}    qty             The number of spots we are moving
             * @return {obj}                    A promise
             */
            move: function(activityId, accessKey, fromVolId, toVolId, jobId, qty) {
                var data = {
                    activity_id:        activityId,
                    accesskey:          accessKey,
                    from_volunteer_id:  fromVolId,
                    to_volunteer_id:    toVolId,
                    job_id:             jobId,
                    quantity:           qty
                };

                return Assigners.move(data);
            },

            /**
             * Return a list of the assignmnet a user has, or the assignments they are managing
             * @param  {int}    activityId      Id of the activity
             * @param  {str}    accessKey       Access key to authenticate the user with
             * @param  {bool}   includePast     Should include past assignments?
             * @return {obj}                    A promise
             */
            myAssignments: function(activityId, accessKey, includePast) {
                return Assigners.myAssignments({
                    activity_id:    activityId,
                    accesskey:      accessKey,
                    include_past:   includePast
                });
            },

            /**
             * Remove assignments from a user
             * @param  {int}    activityId      Id of the activity
             * @param  {str}    accessKey       Access key to authenticate the user with
             * @param  {int}    volunteerId     Id of the volunteer to remove assignmetns for
             * @param  {int}    jobAssId        The id of the job this assignment is for
             * @param  {int}    quantity        The number of spots we are removing
             * @return {obj}                    A promise
             */
            removeAssignments: function(activityId, accessKey, volunteerId, jobAssId, quantity) {
                return Assigners.removeAssignments({
                    activity_id:        activityId,
                    accesskey:          accessKey,
                    volunteer_id:       volunteerId,
                    jobassignment_id:   jobAssId,
                    quantity:           quantity
                });
            }
        };
    }];
});

